import React from 'react';
import Container from 'react-bootstrap/Container';

const NotFound = () => {
  return (
    <Container fluid>
      <h2>404 - Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </Container>
  );
};

export default NotFound;